export enum SeverityTag {
  Success = 'success',
  Info = 'info',
  Warning = 'warning',
  Danger = 'danger'
}
